import React from "react";
import { inputBaseClasses, MenuItem, Stack, Typography } from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";
import { ZoomSvg } from "@onair/ui/svg/zoom";
import { GoogleMeetSvg } from "@onair/ui/svg/google-meet";
import { OnAirSvg } from "@onair/ui/svg/onair";
import { ExtendRoomProvider } from "@onair/constants";

interface PropTypes {
	prefixName: string;
	isFree: boolean;
	roomProvider: ExtendRoomProvider | undefined;
}

const EventRoomSelect: React.FC<PropTypes> = ({
	prefixName,
	isFree,
	roomProvider,
}) => {
	return (
		<Stack spacing={2}>
			<Field.Select
				name={`${prefixName}.roomProvider`}
				label="Nền tảng tổ chức sự kiện"
				sx={{
					flex: 1,
					"& .selectedHide": {
						display: "none",
					},
					[`& .${inputBaseClasses.root}`]: {
						backgroundColor: "white",
					},
				}}
				required
				value={roomProvider}
			>
				{[
					{
						label: (
							<Stack direction="row" spacing={1}>
								<ZoomSvg />
								<Typography variant="body2">Zoom</Typography>
							</Stack>
						),
						value: ExtendRoomProvider.ZOOM,
					},
					{
						label: (
							<Stack direction="row" spacing={1}>
								<GoogleMeetSvg />
								<Typography variant="body2">Google Meet</Typography>
							</Stack>
						),
						value: ExtendRoomProvider.GOOGLE_MEET,
					},
				].map((el) => {
					return (
						<MenuItem
							key={el.value}
							value={el.value}
							// @ts-ignore
							disabled={el.disabled || false}
						>
							{el.label}
						</MenuItem>
					);
				})}
			</Field.Select>
			{roomProvider && roomProvider !== ExtendRoomProvider.SYSTEM && (
				<Field.Text
					name={`${prefixName}.roomUrl`}
					label="Link URL"
					required
					sx={{
						[`& .${inputBaseClasses.root}`]: {
							backgroundColor: "white",
						},
					}}
				/>
			)}
			{roomProvider === ExtendRoomProvider.ZOOM && (
				<Stack
					sx={{
						flexDirection: {
							xs: "column",
							md: "row",
						},
					}}
					spacing={2}
				>
					<Field.Text
						name={`${prefixName}.roomInfo.id`}
						label="Zoom Meeting ID"
						sx={{
							[`& .${inputBaseClasses.root}`]: {
								backgroundColor: "white",
							},
						}}
					/>
					<Field.Text
						name={`${prefixName}.roomInfo.password`}
						label="Password"
						sx={{
							[`& .${inputBaseClasses.root}`]: {
								backgroundColor: "white",
							},
						}}
					/>
				</Stack>
			)}
		</Stack>
	);
};

export default EventRoomSelect;
